import React, { useMemo } from 'react';

import { SHIPPING_ERROR_TOOLTIP_TEXT } from '../../../constants/oneLink';
import { OLShippingDetailsContainer } from '../../../containers';
import { IOneLinkErrors, OneLinkChunksEnum } from '../../../contexts/OneLinkSummaryProvider';
import { IOneLinkWithCampaignSummaries } from '../../../types/oneLink';
import { Section } from './common';

interface IProps {
  onEdit?: () => void;
  instance: IOneLinkWithCampaignSummaries | null | undefined;
  errors?: IOneLinkErrors;
}

export const ShippingSection: React.FC<IProps> = ({ onEdit, errors, instance }) => {
  const shippingValues = useMemo(
    () => ({
      is_receiver_address_fixed: !!instance?.is_receiver_address_fixed,
      receiver_address: instance?.receiver_fixed_address,
      org_address_ids: instance?.org_address_ids,
    }),
    [instance],
  );

  const shippingErrors = useMemo(
    () => ({
      receiver_fixed_address: errors?.[OneLinkChunksEnum.ShippingInfo]?.receiver_fixed_address,
      org_address_ids: errors?.[OneLinkChunksEnum.ShippingInfo]?.org_address_ids,
    }),
    [errors],
  );

  const shippingError = useMemo(() => {
    return shippingErrors.org_address_ids || shippingErrors.receiver_fixed_address;
  }, [shippingErrors]);

  return (
    <Section
      title="Shipping"
      tooltipText={SHIPPING_ERROR_TOOLTIP_TEXT}
      onEdit={onEdit}
      minHeight={420}
      errors={shippingError}
    >
      <OLShippingDetailsContainer error={!!shippingError} isReadOnly mui values={shippingValues} />
    </Section>
  );
};

export default ShippingSection;
